import {Ease} from "../../core/Animatable";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class FloatAnimation extends Animation {

    public animate(item: SceneItem, context: AnimationContext, cb: () => void): void {
        const y = item.y - item.getLocalBounds().height * 0.1 * (this.speed || 1);
        item.moveYTo(y, this.time || 1, Ease.sineInOut, {
            delay: this.delay,
            repeat: -1,
            yoyo: true,
            onUpdate: () => this.updatePaperCut(item),
            onStart: () => {
                cb();
            },
        });
    }
}
